<template>
  <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1351_12189)">
      <g clip-path="url(#clip1_1351_12189)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.9549 10.9152C27.3668 10.5693 26.6373 10.5693 26.0491 10.9152L10.0739 20.3124C10.0301 20.3382 9.98764 20.3656 9.94649 20.3945C9.93236 20.4021 9.91832 20.4099 9.90434 20.4179C9.31912 20.7526 8.95801 21.3751 8.95801 22.0493V40.3038C8.95801 40.9698 9.31048 41.5861 9.88453 41.9237L25.8597 51.3209C26.4479 51.6669 27.1774 51.6669 27.7655 51.3209L43.7407 41.9237C44.3148 41.5861 44.6672 40.9698 44.6672 40.3038V22.7546C44.7899 22.5025 44.8566 22.2221 44.8566 21.9324C44.8566 21.2664 44.5042 20.6501 43.9301 20.3124L27.9549 10.9152ZM27.002 29.149L14.7337 21.9324L27.002 14.7157L39.2704 21.9324L27.002 29.149ZM40.9084 39.2288L28.6921 46.4149V32.5214L40.9084 25.3353V39.2288Z"
          fill="#E0E0E0"
        />
        <path
          d="M6.37373 27.9961L9.95904 22.6181L25.0896 31.4036L21.8287 37.2008C21.5959 37.6146 21.0681 37.7558 20.6598 37.5134L6.64565 29.1925C6.22911 28.9451 6.10502 28.3992 6.37373 27.9961Z"
          fill="#F9F9F9"
          stroke="#E0E0E0"
          stroke-width="2.81915"
        />
        <path
          d="M47.5862 28.0181L44.0009 22.6401L28.8703 31.4256L32.1312 37.2227C32.364 37.6366 32.8919 37.7778 33.3002 37.5353L47.3143 29.2144C47.7308 28.9671 47.8549 28.4211 47.5862 28.0181Z"
          fill="#F9F9F9"
          stroke="#E0E0E0"
          stroke-width="2.81915"
        />
      </g>
      <g clip-path="url(#clip2_1351_12189)">
        <path
          d="M37.1475 11.1489C37.1475 16.754 32.6036 21.2979 26.9985 21.2979C21.3934 21.2979 16.8496 16.754 16.8496 11.1489C16.8496 5.54383 21.3934 1 26.9985 1C32.6036 1 37.1475 5.54383 37.1475 11.1489Z"
          fill="#E0E0E0"
        />
        <path
          d="M23.6162 7.76611L30.3822 14.5321M30.3822 7.76611L23.6162 14.5321"
          stroke="white"
          stroke-width="2.25532"
          stroke-linecap="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1351_12189">
        <rect width="54" height="54" fill="white" />
      </clipPath>
      <clipPath id="clip1_1351_12189">
        <rect
          width="45.1064"
          height="45.1064"
          fill="white"
          transform="translate(4.44727 8.89355)"
        />
      </clipPath>
      <clipPath id="clip2_1351_12189">
        <rect width="20.2979" height="20.2979" fill="white" transform="translate(16.8506 1)" />
      </clipPath>
    </defs>
  </svg>
</template>
